/**
 * Today as `yyyy-MM-dd` in the viewer's own timezone.
 *
 * Deliberately not `new Date().toISOString().slice(0, 10)`, which converts to UTC first and so
 * reports yesterday for anyone east of UTC in the evening — a user in UTC+13 would be told their
 * own "today" is in the past (SC-264).
 */
export function todayIso(): string {
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${month}-${day}`;
}
